<div class="relative">
  <div
    class="absolute inset-0 flex items-start justify-center pointer-events-none"
  >
    <div class="w-full max-w-[900px] mx-auto rounded-lg step-bg"></div>
  </div>

  <div class="step-card">
    @if (showValidationAlert) {
      <div class="alert-card" role="alert" aria-live="polite">
        <button
          type="button"
          class="alert-close"
          aria-label="Fermer le message d'erreur"
          (click)="showValidationAlert = false"
        >
          <span class="material-icons">close</span>
        </button>
        <div class="alert-title">Formulaire incomplet</div>
        <div class="alert-body">
          Veuillez renseigner les champs suivants :
          <ul>
            @for (field of missingFields; track field) {
              <li>{{ field }}</li>
            }
          </ul>
        </div>
      </div>
    }

    <form
      [formGroup]="generaleForm"
      (ngSubmit)="onSubmitToLocalStorage()"
      class="step-form"
    >
      <div class="form-section">
        <div class="form-row">
          <div class="field">
            <app-select
              label="Programme"
              formControlName="programmeSelect"
              [options]="programmes"
              [loading]="loadingProgrammeSelect"
            ></app-select>
            @if (
              generaleForm.get("programmeSelect")?.touched &&
              generaleForm.get("programmeSelect")?.invalid
            ) {
              <small class="field-error"
                >Le champ 'Programme' est requis.</small
              >
            }
          </div>
          <div class="field">
            <app-select
              label="Type"
              formControlName="typeCodeSelect"
              [options]="types"
              [loading]="loadingTypes"
            ></app-select>
            @if (
              generaleForm.get("typeCodeSelect")?.touched &&
              generaleForm.get("typeCodeSelect")?.invalid
            ) {
              <small class="field-error">Le champ 'Type' est requis.</small>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <app-select
              [label]="getTypeLabel()"
              formControlName="typeInterventionSelect"
              [options]="resultatStructures"
              [loading]="loadingStructures"
            ></app-select>
            @if (
              generaleForm.get("typeInterventionSelect")?.touched &&
              generaleForm.get("typeInterventionSelect")?.invalid
            ) {
              <small class="field-error">
                Veuillez sélectionner {{ getTypeLabel() }}.
              </small>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <app-input
              type="text"
              formControlName="activities"
              label="{{ getTypeLabelActivite() }}"
            ></app-input>
            @if (
              generaleForm.get("activities")?.touched &&
              generaleForm.get("activities")?.invalid
            ) {
              <small class="field-error"
                >Le champ 'Activités' est requis.</small
              >
            }
          </div>
          <div class="field">
            <app-input
              label="Description"
              type="text"
              formControlName="description"
            ></app-input>
          </div>
        </div>

        <div class="form-row">
          <div class="field">
            <app-input
              type="date"
              formControlName="dateDebut"
              label="Date de début"
              [max]="activityEndDate"
            ></app-input>
            @if (
              generaleForm.get("dateDebut")?.touched &&
              (generaleForm.get("dateDebut")?.invalid || generaleForm.hasError("dateOrder"))
            ) {
              <small class="field-error">
                @if (generaleForm.get("dateDebut")?.hasError("required")) {
                  La date de début est requise.
                } @else {
                  La date de début doit être antérieure ou égale à la date de fin.
                }
              </small>
            }
          </div>
          <div class="field">
            <app-input
              label="Date de fin"
              type="date"
              formControlName="dateFin"
              [min]="activityStartDate"
            ></app-input>
            @if (
              generaleForm.get("dateFin")?.touched &&
              (generaleForm.get("dateFin")?.invalid || generaleForm.hasError("dateOrder"))
            ) {
              <small class="field-error">
                @if (generaleForm.get("dateFin")?.hasError("required")) {
                  La date de fin est requise.
                } @else {
                  La date de fin doit être postérieure ou égale à la date de début.
                }
              </small>
            }
          </div>
        </div>

        @if (canAddTasks()) {
          <div class="tasks-section" formArrayName="taches">
            <div class="tasks-header">
              <div>
                <h4 class="tasks-title">Tâches</h4>
                <p class="tasks-description">Ajoutez les sous-activités de cette activité.</p>
                <p class="tasks-total" [class.tasks-total--invalid]="taskWeightError">
                  Total des poids : {{ totalTaskWeight }} / 100
                </p>
              </div>
              <button type="button" class="btn btn-secondary btn-md" (click)="addTask()">
                <span class="material-icons btn-icon btn-icon--left">add</span>
                Ajouter une tâche
              </button>
            </div>

            @if (taskWeightError) {
              <p class="task-weight-error" role="alert">
                La somme des poids des tâches doit être exactement égale à 100.
                Total actuel : {{ totalTaskWeight }}.
              </p>
            }

            @for (task of tachesFormArray.controls; track $index) {
              <div class="task-row" [formGroupName]="$index">
                <div class="field">
                  <app-input type="text" formControlName="titreTache" label="Libellé"></app-input>
                </div>
                <div class="field">
                  <app-input
                    type="date"
                    formControlName="dateDebut"
                    label="Date de début"
                    [min]="activityStartDate"
                    [max]="taskEndDate($index) || activityEndDate"
                  ></app-input>
                </div>
                <div class="field">
                  <app-input
                    type="date"
                    formControlName="dateFin"
                    label="Date de fin"
                    [min]="taskStartDate($index) || activityStartDate"
                    [max]="activityEndDate"
                  ></app-input>
                </div>
                <div class="field task-weight-field">
                  <app-input
                    type="number"
                    formControlName="poids"
                    label="Poids"
                    placeholder="30"
                    [noIcon]="true"
                  ></app-input>
                </div>
                <button
                  type="button"
                  class="task-remove"
                  (click)="removeTask($index)"
                  [attr.aria-label]="'Supprimer la tâche ' + ($index + 1)"
                >
                  <span class="material-icons">delete</span>
                </button>
                @if (task.invalid && task.touched) {
                  <small class="field-error task-error">
                    @if (task.hasError("outsideActivity")) {
                      Les dates de la tâche doivent être comprises dans la période de l'activité.
                    } @else if (task.hasError("dateOrder")) {
                      La date de début doit être antérieure ou égale à la date de fin.
                    } @else {
                      Libellé, dates et poids sont requis pour cette tâche.
                    }
                  </small>
                }
              </div>
            }
          </div>
        }
      </div>

      <!--
        ⚠️  IMPORTANT — bouton natif obligatoire pour déclencher (ngSubmit).
        app-ui-button génère son propre <button> dans un shadow DOM partiel ;
        Angular ne relie pas ce bouton au <form> parent.
        On stylise ici avec les classes du design system.
      -->
      <div class="actions">
        <button
          type="button"
          class="btn btn-danger btn-md"
          [routerLink]="['/activities/activity']"
        >
          <span class="material-icons btn-icon btn-icon--left">close</span>
          Annuler
        </button>
        <button type="submit" class="btn btn-primary btn-md">
          Suivant
          <span class="material-icons btn-icon btn-icon--right"
            >arrow_right_alt</span
          >
        </button>
      </div>
    </form>
  </div>
</div>
